export default __webpack_public_path__ + "static/media/banner-0.fda4026b.jpg";